import axios from "axios";
import React, { useState } from "react";
import { Modal } from 'react-bootstrap';
import { getBranchOwner } from "@config";
import { aiRegisterClient } from "../../../../../api/nfse";
import ClientesFilter from '../../../../AppViews/Clients/components/Filter';
import { getStateUf } from "../utils";
import { useNfse } from "../context";
import { StyledCard, StyledCardHeader, SectionTitle, ActionButton } from './styles';

const formatCpfCnpj = (value) => {
  if (!value) return "";
  const cleaned = String(value).replace(/\D/g, "");
  if (cleaned.length === 11) return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  if (cleaned.length === 14) return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  return value;
};

const formatCep = (value) => {
  if (!value) return "";
  const cleaned = String(value).replace(/\D/g, "");
  if (cleaned.length === 8) return cleaned.replace(/(\d{5})(\d{3})/, "$1-$2");
  return value;
};

export default function Taker(props) {
  const { taker, setTaker } = useNfse();
  const [loading, setLoading] = useState(false);
  const [registering, setRegistering] = useState(false);
  const [cpfCnpjMask, setCpfCnpjMask] = useState("99.999.999/9999-99");
  const [manual, setManual] = useState(false);
  const [showModalSearchClient, setShowModalSearchClient] = useState(false);

  const openModalSearchClient = () => setShowModalSearchClient(true);
  const closeModalSearchClient = () => setShowModalSearchClient(false);

  const changeData = (data) => {
    setTaker(prev => ({ ...prev, [data.key]: data.value }));
  };

  const handleRegisterClient = () => {
    if (!taker || (!taker.name && !taker.cpf_cnpj)) return;
    const branch = getBranchOwner();
    if (!branch || !branch.id) return;

    setRegistering(true);
    aiRegisterClient({ taker }, { branch_owner: branch.id })
      .then((response) => {
        const data = (response && response.data) ? response.data : response;
        if (data && data.client && data.client.original_id) {
          setTaker(prev => ({ ...prev, ...data.client, original_id: data.client.original_id }));
        }
      })
      .catch((err) => {
        console.error("Erro ao cadastrar cliente:", err);
      })
      .finally(() => {
        setRegistering(false);
      });
  };

  const onSearchCep = () => {
    const url = `https://viacep.com.br/ws/${taker.postal_code}/json/`;
    setLoading(true);
    axios
      .get(url)
      .then((resp) => {
        changeData({ key: "address", value: resp.data["logradouro"] });
        changeData({ key: "state", value: resp.data["uf"] });
        changeData({ key: "district", value: resp.data["bairro"] });
        changeData({ key: "city", value: resp.data["localidade"] });
        changeData({ key: "city_code", value: resp.data["ibge"] });

        setTimeout(() => {
          setLoading(false);
        }, 50);
      })
      .catch((error) => { });
  };

  const checkMask = (doc) => {
    let mask = "";
    if (doc) doc = doc.replace(/\D/g, '');
    if (!doc || doc.length <= 11) {
      mask = "999.999.999-999";
    } else {
      mask = "99.999.999/9999-99";
    }
    setCpfCnpjMask(mask);
  };

  const handleChangeField = (e) => {
    if (typeof e === "string") {
      changeData({ key: "phone_number", value: e });
      return;
    }
    let { name: key, value } = e.target;
    if (key === "postal_code") {
      value = value.replace(/\D+/g, "");
      if (value.length > 8) return;
    } else if (key === "cpf_cnpj") {
      checkMask(value);
    }
    changeData({ key, value });
  };

  const onSelect = (client) => {
    let cpfCnpj = "";
    if (client.individual) {
      setCpfCnpjMask("999.999.999-99");
      cpfCnpj = client.individual.cpf || "";
    } else if (client.company) {
      setCpfCnpjMask("99.999.999/9999-99");
      cpfCnpj = client.company.cnpj || "";
    } else if (client.cpf_cnpj) {
      cpfCnpj = client.cpf_cnpj;
      checkMask(cpfCnpj);
    }

    let state = client.address ? (client.address.uf || getStateUf(client.address.state)) : "";

    let data = {
      original_id: client.original_id || client.id,
      cpf_cnpj: cpfCnpj,
      name: client.name,
      phone_number: client.phone_number || "",
      email: client.email || "",
      postal_code: client.address ? client.address.postal_code : "",
      district: client.address ? client.address.district : "",
      city: client.address ? client.address.city : "",
      city_code: client.address ? (client.address.city_code || client.address.ibge_code) : "",
      address: client.address ? (client.address.street || client.address.address) : "",
      street: client.address ? client.address.street : "",
      street_number: client.address ? client.address.street_number : "",
      state: state
    };

    setTaker(data);
    setManual(false);
    setShowModalSearchClient(false);
  };

  const hasTakerInfo = Boolean(taker && (taker.name || taker.cpf_cnpj));
  const isRegisteredClient = Boolean(taker && taker.original_id);

  return (
    <StyledCard>
      <StyledCardHeader>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <SectionTitle><i className="fas fa-user-tie"></i> Dados do Tomador</SectionTitle>
          {hasTakerInfo && (
            isRegisteredClient ? (
              <span style={{
                background: '#ECFDF3',
                color: '#067647',
                border: '1px solid #ABEFC6',
                borderRadius: '16px',
                padding: '3px 10px',
                fontSize: '0.75rem',
                fontWeight: 700,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '5px'
              }}>
                <i className="fas fa-check-circle" style={{ color: '#17B26A' }}></i> Cliente Cadastrado
              </span>
            ) : (
              <span style={{
                background: '#FEF3F2',
                color: '#B42318',
                border: '1px solid #FECDCA',
                borderRadius: '16px',
                padding: '3px 10px',
                fontSize: '0.75rem',
                fontWeight: 700,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '5px'
              }}>
                <i className="fas fa-triangle-exclamation" style={{ color: '#D92D20' }}></i> Tomador Não Cadastrado
              </span>
            )
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          {hasTakerInfo && !isRegisteredClient && (
            <ActionButton variant="primary" onClick={handleRegisterClient} disabled={registering} style={{ fontSize: '0.82rem', padding: '6px 12px' }} $stackedOnMobile>
              <i className={"fas fa-" + (registering ? "circle-notch fa-spin" : "user-plus")} style={{ marginRight: '6px' }}></i>
              {registering ? "Cadastrando..." : "Cadastrar como Cliente"}
            </ActionButton>
          )}
          <ActionButton variant={hasTakerInfo ? "secondary" : "primary"} onClick={(e) => { e.preventDefault(); openModalSearchClient(); }} $stackedOnMobile>
            {hasTakerInfo ? "Alterar Tomador" : "Selecionar Tomador"}
          </ActionButton>
        </div>
      </StyledCardHeader>
      
      <Modal size="lg" show={showModalSearchClient} onHide={closeModalSearchClient}>
        <Modal.Header closeButton>
          <Modal.Title>Selecionar Tomador</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ClientesFilter onClick={onSelect} modalBehavior />
        </Modal.Body>
      </Modal>

      {hasTakerInfo && !isRegisteredClient && (
        <div style={{
          background: '#FFF4ED',
          border: '1px solid #FDCF8A',
          borderRadius: '8px',
          padding: '12px 16px',
          marginBottom: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          flexWrap: 'wrap'
        }}>
          <span style={{ color: '#7A2E0E', fontSize: '0.86rem', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
            <i className="fas fa-triangle-exclamation" style={{ color: '#D92D20', fontSize: '1rem' }}></i>
            Este tomador não está cadastrado na base. É obrigatório cadastrá-lo como cliente para emitir a NFS-e.
          </span>
          <ActionButton variant="primary" onClick={handleRegisterClient} disabled={registering} style={{ fontSize: '0.8rem', padding: '6px 14px' }} $stackedOnMobile>
            <i className={"fas fa-" + (registering ? "circle-notch fa-spin" : "user-plus")}></i>
            {registering ? "Cadastrando..." : "Cadastrar Agora"}
          </ActionButton>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div style={{ background: '#F9FAFB', padding: '16px', borderRadius: '8px', border: '1px solid #EAECF0', minHeight: '96px' }}>
          <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#667085', textTransform: 'uppercase' }}>Razão Social</span>
          <p style={{ margin: 0, marginTop: '8px', fontWeight: 600, fontSize: '1.05rem', wordBreak: 'break-word' }}>{(taker && taker.name) || "Nenhum selecionado"}</p>
        </div>

        <div style={{ background: '#F9FAFB', padding: '16px', borderRadius: '8px', border: '1px solid #EAECF0', minHeight: '96px' }}>
          <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#667085', textTransform: 'uppercase' }}>Documento</span>
          <p style={{ margin: 0, marginTop: '8px', fontWeight: 600, fontSize: '1.05rem', wordBreak: 'break-word' }}>{formatCpfCnpj((taker && taker.cpf_cnpj) || "") || "Nenhum selecionado"}</p>
        </div>

        <div style={{ background: '#F9FAFB', padding: '16px', borderRadius: '8px', border: '1px solid #EAECF0', minHeight: '96px' }}>
          <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#667085', textTransform: 'uppercase' }}>Endereço Completo</span>
          <p style={{ margin: 0, marginTop: '8px', fontWeight: 500, wordBreak: 'break-word' }}>
            {(taker && (taker.postal_code || taker.street || taker.address || taker.city)) ? 
              `${taker.postal_code ? formatCep(taker.postal_code) + ", " : ""}${(taker.street || taker.address || "")} ${(taker.street_number || "")}${taker.district ? ", " + taker.district : ""}${taker.city ? ", " + taker.city : ""}${(taker.state ? "/" + taker.state : "")}`
              : "Nenhum endereço registrado"}
          </p>
        </div>
      </div>
    </StyledCard>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/emit/components/taker.jsx